import React from "react";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import Select from "../../../controls/Select";

function SCorpInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Legal information</span>
        </div>
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.legalName)}
          placeholder="Legal Name of the S-Corporation"
          defaultInvalidMessage="Please provide a valid corporation name"
          value={values[FORM_FIELD_KEYS.legalName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.dbaname)}
          value={values[FORM_FIELD_KEYS.dbaname]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.organizedState)}
          value={values[FORM_FIELD_KEYS.organizedState]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          hideDivider
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default SCorpInfoBlock;
